export default __webpack_public_path__ + "static/media/tick.f7b10533.svg";